<template>
    <v-dialog v-model="show" max-width="80%" persistent>
        <div class="locker_modal__modal_header">
            <v-btn flat @click="$emit('close-locker-modal')">Cerrar</v-btn>
        </div>
        <div class="locker_modal__modal_body">
            <button
                @click="openFormDialog()"
                class="locker_modal__modal_body--button_add">
                <v-icon>add</v-icon> Nuevo Locker
            </button>
            <v-layout row>
                <v-flex xs12 sm6 offset-sm3>
                    <v-card>
                        <v-toolbar color="#1476FB" dark>
                            <v-icon>lock</v-icon>
                            <v-toolbar-title>Lockers</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <template v-if="lockers.length === 0">
                            <v-list-tile :key="index">
                                <v-list-tile-content>
                                    <v-list-tile-title>No tienes lockers creados en este momento</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                        <v-list two-line>
                            <template v-for="(locker, index) in lockers">
                                <v-list-tile :key="index">
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ locker.name }}</v-list-tile-title>
                                        <v-list-tile-sub-title>{{ locker.sublocation_type }}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn @click="openQrDialog(locker)" icon>
                                            <v-icon color="grey lighten-1">qr_code</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                    <v-list-tile-action>
                                        <v-btn icon @click="openFormDialog(locker)">
                                            <v-icon color="grey lighten-1">edit</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider v-if="index + 1 < lockers.length" :key="`divider-${index}`"></v-divider>
                            </template>
                        </v-list>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-dialog v-model="show_form_dialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        {{ edited_locker_id === null ? 'Crear Locker' : 'Actualizar Locker' }}
                    </v-card-title>
                    <v-card-text>
                        <v-flex xs12 sm6 md12>
                            <v-text-field v-model="locker_name" label="Nombre o número del locker*" required></v-text-field>
                        </v-flex>
                    </v-card-text>
                    <v-card-actions class="locker_modal__modal_body--btn_section">
                        <v-btn color="primary" @click="show_form_dialog=false"><v-icon>cancel</v-icon> Cancelar</v-btn>
                        <v-btn color="primary" v-if="edited_locker_id === null" @click="createLocker()"><v-icon>save</v-icon> Crear</v-btn>
                        <v-btn color="primary" v-else @click="updateLocker()"><v-icon>save</v-icon> Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="show_qr_dialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        QR del Locker {{ qr_locker_selected.name }}
                    </v-card-title>
                    <v-card-actions>
                        <vue-qrcode class="locker_modal__modal_body--qr_code"
                            :value="'https://delivery.fusepong.com/#/?id='+getCompany().id+'&locker_location_id='+qr_locker_selected.location_id">
                        </vue-qrcode>
                    </v-card-actions>
                    <v-card-actions class="locker_modal__modal_body--btn_section">
                        <v-btn color="primary" @click="show_qr_dialog = false"><v-icon>cancel</v-icon> Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </v-dialog>
</template>

<script>
    export default {
        data(){
            return{
                show: true,
                selected_support_id: null,
                lockers: [],
                show_form_dialog: false,
                locker_name: '',
                edited_locker_id: null,
                show_qr_dialog: false,
                qr_locker_selected: {}
            }
        },
        props:{
            location_id: {
                type: Number
            },
        },
        watch: {

        },
        methods:{
            getLocationLockers(value){
                try {
                    this.$http.get('app/sublocations/get_locker_sublocations',{
                        params:{
                            location_id: this.location_id,
                        },
                        headers:
                            {
                                "X-Device-ID" : this.getDeviceId(),
                                "Authorization" : 'Bearer ' + this.getUserToken()
                            }
                        }
                    ).then(function(response){
                        this.lockers = response.body.data;
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                    }, function(response){
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                        if (response.status==401) {
                            this.updateAlertMessage("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
                            this.updateIsInAlert(true)
                        }else{
                            if(response.body.ans !== undefined && response.body.ans !== null && response.body.ans !== ''){
                                this.updateAlertMessage(response.body.ans);
                                this.updateIsInAlert(true)
                            }else{
                                if (response.body.errors[0].title != null && response.body.errors[0].title != undefined && response.body.errors[0].title != '' ){
                                    this.updateAlertMessage(response.body.errors[0].title);
                                    this.updateIsInAlert(true)
                                }else{
                                    if(typeof response.body.errors[0].details != "object"){
                                        this.updateAlertMessage(response.body.errors[0].details);
                                        this.updateIsInAlert(true)
                                    }else{
                                        let message = []
                                        for(var key in response.body.errors[0].details){
                                            message.push(response.body.errors[0].details[key])
                                        }
                                        this.updateAlertMessage(message);
                                        this.updateIsInAlert(true)
                                    }
                                }
                            }

                        }
                    })
                } catch (e) {
                    alert(e.message)
                }
            },
            createLocker(){
                var data = { name: this.locker_name, location_id: this.location_id }
                try {
                    this.$http.post('app/sublocations/create_locker_sublocation',{ data: this.encrypt(data).toString()},
                    {
                        headers:{
                            "X-Device-ID" : this.getDeviceId(),
                            "Authorization" : 'Bearer ' + this.getUserToken()
                        }
                    })
                    .then(function(response){
                        this.show_form_dialog = false
                        this.updateAlertMessage(response.body.ans)
                        this.updateIsInAlert(true)
                        this.getLocationLockers()
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                    }, function(response){
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                        if (response.status==401) {
                            this.updateAlertMessage("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
                            this.updateIsInAlert(true)
                        }else{
                            if(response.body.ans !== undefined && response.body.ans !== null && response.body.ans !== ''){
                                this.updateAlertMessage(response.body.ans);
                                this.updateIsInAlert(true)
                            }else{
                                if (response.body.errors[0].title != null && response.body.errors[0].title != undefined && response.body.errors[0].title != '' ){
                                    this.updateAlertMessage(response.body.errors[0].title);
                                    this.updateIsInAlert(true)
                                }else{
                                    if(typeof response.body.errors[0].details != "object"){
                                        this.updateAlertMessage(response.body.errors[0].details);
                                        this.updateIsInAlert(true)
                                    }else{
                                        let message = []
                                        for(var key in response.body.errors[0].details){
                                            message.push(response.body.errors[0].details[key])
                                        }
                                        this.updateAlertMessage(message);
                                        this.updateIsInAlert(true)
                                    }
                                }
                            }

                        }
                    })
                } catch (e) {
                    alert(e.message)
                }
            },
            updateLocker(){
                var data = { name: this.locker_name, sublocation_id: this.edited_locker_id, location_id: this.location_id }
                try {
                    this.$http.post('app/sublocations/update_locker_sublocation',{ data: this.encrypt(data).toString()},
                    {
                        headers:{
                            "X-Device-ID" : this.getDeviceId(),
                            "Authorization" : 'Bearer ' + this.getUserToken()
                        }
                    })
                    .then(function(response){
                        this.show_form_dialog = false
                        this.updateAlertMessage(response.body.ans)
                        this.updateIsInAlert(true)
                        this.getLocationLockers()
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                    }, function(response){
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                        if (response.status==401) {
                            this.updateAlertMessage("Tienes una sesión abierta en otro dispositivo.", "Un momento...");
                            this.updateIsInAlert(true)
                        }else{
                            if(response.body.ans !== undefined && response.body.ans !== null && response.body.ans !== ''){
                                this.updateAlertMessage(response.body.ans);
                                this.updateIsInAlert(true)
                            }else{
                                if (response.body.errors[0].title != null && response.body.errors[0].title != undefined && response.body.errors[0].title != '' ){
                                    this.updateAlertMessage(response.body.errors[0].title);
                                    this.updateIsInAlert(true)
                                }else{
                                    if(typeof response.body.errors[0].details != "object"){
                                        this.updateAlertMessage(response.body.errors[0].details);
                                        this.updateIsInAlert(true)
                                    }else{
                                        let message = []
                                        for(var key in response.body.errors[0].details){
                                            message.push(response.body.errors[0].details[key])
                                        }
                                        this.updateAlertMessage(message);
                                        this.updateIsInAlert(true)
                                    }
                                }
                            }

                        }
                    })
                } catch (e) {
                    alert(e.message)
                }
            },
            openFormDialog(locker){
                this.show_form_dialog = true
                if (locker){
                    this.edited_locker_id = locker.id
                    this.locker_name = locker.name
                }else{
                    this.edited_locker_id = null
                    this.locker_name = ''
                }
            },
            openQrDialog(locker){
                this.show_qr_dialog = true
                this.qr_locker_selected = locker
            }
        },
        mounted(){
            this.getLocationLockers()
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/LockerModal.vue